import { gql } from "@apollo/client";

export const GetMobileDevicesDetails = gql`
  query GetMobileDevicesDetails(
    $token: String!
    $customerID: ID!
    $user_details: SubscribedUser!
  ) {
    GetMobileDevicesDetails(
      token: $token
      customerID: $customerID
      user_details: $user_details
    ) {
      deviceID
      lastLoginDate
      brand
      model
    }
  }
`;
